<template>
  <div class="loading" v-show="loading">
    <div class="pacman">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading',
  props: ['loading']
}
</script>
<style lang="less">
.loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  font-size: 0.42rem;
  color: #aaa;
  text-align: center;
  z-index: 99999;
  background: rgba(255, 255, 255, 0.5);
}

.pacman {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 0.142rem;
  width: 0.34rem;
  transform: translate(-50%, -50%);
  overflow: hidden;
}

.pacman > div:first-of-type,
.pacman > div:nth-child(2) {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  border: 0.07rem solid #59a4dd;
  border-right: 0.07rem solid transparent;
  border-radius: 50%;
  z-index: 10;
}

.pacman > div:nth-child(3) {
  animation: pacman-balls 1.5s 0s infinite linear;
  background-color: #6fe4ca;
}

.pacman > div:nth-child(4) {
  animation: pacman-balls 1.5s 0.5s infinite linear;
  background-color: #8ac4ff;
}

.pacman > div:nth-child(5) {
  animation: pacman-balls 1.5s 1s infinite linear;
  background-color: #ffc171;
}

.pacman > div:first-of-type {
  animation: rotate_pacman_half_up 0.5s 0s infinite;
}

.pacman > div:nth-child(2) {
  animation: rotate_pacman_half_down 0.5s 0s infinite;
}

.pacman > div:nth-child(3),
.pacman > div:nth-child(4),
.pacman > div:nth-child(5),
.pacman > div:nth-child(6) {
  border-radius: 100%;
  width: 0.04rem;
  height: 0.04rem;
  position: absolute;
  transform: translate(0, -0.1875rem);
  top: 0.24rem;
  left: 0.4rem;
}

@keyframes rotate_pacman_half_up {
  0%,
  100% {
    transform: rotate(270deg);
  }
  50% {
    transform: rotate(360deg);
  }
}

@keyframes rotate_pacman_half_down {
  0%,
  100% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(0);
  }
}

@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    transform: translate(-1.89rem, -0.1875rem);
  }
}
</style>